import { NavLink } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import '../../css/General.css';
import './Projeto4.css';
import './Content/Projeto4_Content.css';
import {Projeto4_Header} from './Header/Projeto4_Header';
import {Projeto4_Header_EN} from './Header/Projeto4_Header_EN';
import {Projeto4_Content} from './Content/Projeto4_Content';
import { ProjectsMinimap } from '../Generic/ProjectsMinimap';
import { motion, AnimatePresence } from "framer-motion";
import { NextProjectComponent } from '../Generic/TransitionComponents/NextProjectComponent';

var callBackMinimapaCurrentIndex = 1;

const animation_props = {
    animate: {
      y: '0dvh',
      clipPath: 'inset(0% 0% 0% 0%)',
    },
    initial: {
      y: '25dvh',
      clipPath: 'inset(100% 0% 0% 0%)',
    },
    exit: {
      y: '25dvh',
      clipPath: 'inset(100% 0% 0% 0%)',
    },
    transition: {
      duration: 1,
    }
  }

const sections = [
    <Projeto4_Header />,
    <Projeto4_Content />,
  ];

  const imagens = [
    <div className='p4-d-c-i i0' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i1' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i2' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i3' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i4' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i5' style={{opacity: 1}}/>,
    <div className='p4-d-c-i i6' style={{opacity: 1}}/>,
];

export const Projeto4 = ({callback}) => {

    window.$executarIntro = false;
    window.$projetoAtivo = 4;
    window.$slideAnimation = 0;
    window.$primeiraEntradaSlider = false;

    const refContent1 = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [canScrollBackUp, setCanScrollBackUp] = useState(true);

    const language = localStorage.getItem('language') || 'pt';

    //DRAGGING
    const [scrollPosition, setScrollPosition] = useState(0);
    const [dragging, setDragging] = useState(false);
    const startY = useRef(0);

    const isMobile = window.matchMedia("(max-width: 768px)");
    var x = window.matchMedia("(max-width: 740px)");

    var constanteTamanhoParaScroll = 504.8;//670;
    var constanteTamanhoParaScrollMobile = 182.5;
    const multiplicadorScrollLine = isMobile.matches ? 0.52:0.20;
    if(x.matches){
      constanteTamanhoParaScroll = 20;
    }
    const maxHeightVH = -12 - (constanteTamanhoParaScroll*(sections.length - 1));
    const maxHeightMobileVH = -12 - (constanteTamanhoParaScrollMobile*(sections.length - 1));

    const handleDragStart = (e) => {
      setDragging(true);
      startY.current = e.clientY;
    };

    const handleDragMove = (e) => {
      if (!dragging) return;
      if(!canScrollBackUp){
        return;
      }
      const deltaY = (e.clientY - startY.current) * (e.deltaY > 0 ? 0.2:-0.2);
      startY.current = e.clientY;
      setScrollPosition((prevPosition) => (prevPosition - deltaY) > 0 ? 0:((prevPosition - deltaY)  < maxHeightVH ? maxHeightVH:(prevPosition - deltaY)));
    };

    const handleDragEnd = () => {
      setDragging(false);
    };

    //----------TOUCH DRAG-------
    const handleTouchStart = (e) => {
      setDragging(true);
      startY.current = e.touches[0].clientY;
    };
  
    const handleTouchMove = (e) => {
      if (!dragging) return;
      if(!canScrollBackUp){
        return;
      }

      const deltaY = (e.touches[0].clientY - startY.current) * (e.touches[0].deltaY > 0 ? 0.2:-0.2);
      startY.current = e.touches[0].clientY;
      setScrollPosition((prevPosition) => (prevPosition - deltaY) > 0 ? 0:((prevPosition - deltaY)  < maxHeightMobileVH ? maxHeightMobileVH:(prevPosition - deltaY)));
    };
  
    const handleTouchEnd = () => {
      setDragging(false);
    };

    //----------

    const handleScroll = (e) => {
        
      if(!canScrollBackUp){
        return;
      }

      const deltaY = (e.deltaY > 0 ? -0.1:0.1) * 50; // Positivo - scroll down, negativo - scroll up
      setScrollPosition((prevPosition) => (prevPosition + deltaY) > 0 ? 0:((prevPosition + deltaY) < maxHeightVH ? maxHeightVH:(prevPosition + deltaY)));
    };


    const setHorizontalSlideAnimation = () => {
      window.$slideAnimation = 1;
      callback();
    };

    const setVerticalSlideAnimation = () => {
      window.$slideAnimation = 0;
      callback();
    };
    
    function callbackMinimapa(sIndex, curIndex){
      
        var imagem = document.getElementById("id-p4-content0");
        
        var tamanhoImgEmVH = (imagem.offsetHeight * 100 / window.innerHeight);

        setScrollPosition((prevPosition) => prevPosition + (tamanhoImgEmVH * (callBackMinimapaCurrentIndex - sIndex)));
        setCurrentIndex(sIndex);
        callBackMinimapaCurrentIndex = sIndex;
    }

    function CurrentIndexChanged(currIndex)
    {
        setCurrentIndex(currIndex);
        callBackMinimapaCurrentIndex = currIndex;
    }

    function canScrollBackUpThePage(ableToScrollBackUpPage){
        setCanScrollBackUp(ableToScrollBackUpPage);
    }

    function ScrollDownFromHeader(){
      setScrollPosition(-95);
    }

    return(

        <div className='proj4-detail-container'>
        
        <AnimatePresence>
            {<motion.div {...animation_props} className="portal4" key="portal4!">
                <div className="p4-d-container"
                onMouseDown={handleDragStart}
                onMouseMove={handleDragMove}
                onMouseUp={handleDragEnd}
                onMouseLeave={handleDragEnd}
                onWheel={handleScroll}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                >

                <div className='back-btn' onClick={setVerticalSlideAnimation}>
                        <NavLink to="/" className="slideUp-backbtn">
                          {language === "pt" ? "Anterior":"Back"}
                        </NavLink>
                    </div>

                    <div className="scroll-line" style={{ height: `${-scrollPosition*multiplicadorScrollLine}dvh` }}></div>

                    <div className="projetos-small-menu-slider" style={{opacity: scrollPosition > -85 ? `0`: scrollPosition <= (!isMobile.matches ? -480:-180) ? `0`:`1`}}>
                      <ProjectsMinimap sections={imagens} scrollPosition={scrollPosition} cIndex={currentIndex} handleCallBack={callbackMinimapa}/>
                    </div>

                    <div className="p4-d-s-container"
                        style={{ transform: `translateY(${scrollPosition}vh)` } }
                    >
                            
                        <div
                            className={"p4-s-1"}
                        >
                          {language === "pt" ? 
                            <Projeto4_Header scrollPosition={scrollPosition} scrollDownFromHeader={ScrollDownFromHeader}/>
                            :
                            <Projeto4_Header_EN scrollPosition={scrollPosition} scrollDownFromHeader={ScrollDownFromHeader}/>
                          }
                        </div>
                        <div
                            ref={refContent1}
                            className="p4-s-2"
                            style={{ transition: `transform 1s cubic-bezier(0.215, 0.61, 0.355, 1)`, transform: `translateY(${scrollPosition*.2}vh)`}}
                        >
                            <Projeto4_Content scrollPosition={scrollPosition} handleCallBack={CurrentIndexChanged}/>

                            <div className='next-project4-section'>
                                <NextProjectComponent canMoveNextProject={!isMobile.matches ? scrollPosition <= -504.8:scrollPosition <= -190}
                                handleCallBackScroll={canScrollBackUpThePage}
                                nextProject="Logótipo Andrik" 
                                nextProjectRoute="andrik"
                                nextProjectImage={!isMobile.matches ? "https://live.staticflickr.com/65535/53358698344_a4ce1c4a3f_k.jpg":"https://live.staticflickr.com/65535/53373814813_05ac67705c_c.jpg"} />
                            </div>
                        </div>

                    </div>
                </div>
            </motion.div>}
        </AnimatePresence>

  </div>
    );
}